import { isChinaUser } from 'utils/ChinaUtil';
import {
    FETCH_ACTIVITY_MAP_DETAILS,
    FETCH_ACTIVITY_MAP_DETAILS_BAIDU,
    FETCH_ACTIVITY_MAP_DETAILS_DONE
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    entities: {},
    fetching: {}
};

/** redux selectors */
const selectActivityMapDetailsReducer = (state) => {
    return state.activityMapDetailsReducer;
};

export const selectActivityMapDetails = (state, activityId) => {
    const reducer = selectActivityMapDetailsReducer(state);
    return reducer.entities[activityId]?.data;
};

export const selectActivityMapDetailsFetching = (state, activityId) => {
    const reducer = selectActivityMapDetailsReducer(state);
    return reducer.fetching[activityId];
};

/** redux actions */

/**
 *
 * @param {number} activityId
 * @param {{
 *  maxPolylineSize?: number;
 *  maxHeatMapSize?: number;
 *  splitTypes?: string[];
 * }} options
 * @returns
 */
export const fetchActivityMapDetails = (activityId, { maxPolylineSize, maxHeatMapSize, splitTypes } = {}) => {
    return {
        type: isChinaUser() ? FETCH_ACTIVITY_MAP_DETAILS_BAIDU : FETCH_ACTIVITY_MAP_DETAILS,
        activityId,
        maxPolylineSize,
        maxHeatMapSize,
        splitTypes
    };
};
export const fetchActivityMapDetailsDone = (activityId, { error, data }) => {
    return {
        type: FETCH_ACTIVITY_MAP_DETAILS_DONE,
        activityId,
        error,
        data
    };
};

/** redux handlers */
const handleFetchActivityMapDetails = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.activityId]: {
                ...state.entities[action.activityId],
                error: false
            }
        },
        fetching: {
            ...state.fetching,
            [action.activityId]: true
        }
    };
};

const handleFetchActivityMapDetailsDone = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.activityId]: {
                error: action.error,
                data: action.data
            }
        },
        fetching: {
            ...state.fetching,
            [action.activityId]: false
        }
    };
};

const handlers = {
    [FETCH_ACTIVITY_MAP_DETAILS]: handleFetchActivityMapDetails,
    [FETCH_ACTIVITY_MAP_DETAILS_DONE]: handleFetchActivityMapDetailsDone
};

export default function activityMapDetailsReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return handler(state, action);
}
